const icon = require('vue-svgicon');
icon.register({
    'magnifier-plus': {
        width: 18,
        height: 18,
        viewBox: '0 0 18 18',
        data: `<path pid="0" clip-rule="evenodd" d="M16.86 16.86a.476.476 0 01-.673 0l-4.458-4.457c-1.138.984-2.604 1.6-4.227 1.6a6.501 6.501 0 116.5-6.502c0 1.624-.615 3.09-1.599 4.229l4.458 4.457a.476.476 0 010 .674zm-3.857-9.359a5.502 5.502 0 10-11.004.002A5.502 5.502 0 0013.003 7.5zM8 8.001h2.501a.5.5 0 100-1h-2.5v-2.5a.5.5 0 00-1 0V7H4.5a.5.5 0 000 1h2.501v2.501a.5.5 0 001 0V8.001z"/>`,
    },
});
